﻿import emojiBaseDataGroups from 'emojibase-data/meta/groups.json';
import { FormHeaderView } from 'ckeditor5';
import { createDropdown, addListToDropdown, Collection, Model } from 'ckeditor5';

function createHeaderView(locale) {
    const { t } = locale;

    const groupDropdown = createDropdown(locale);
    const groups = getEmojiGroups(groupDropdown, locale);

    groupDropdown.set({
        value: groups.first.model.label
    });
    groupDropdown.buttonView.set({
        isOn: false,
        withText: true,
        tooltip: t('Emoji category'),
        class: ['ck-dropdown__button_label-width_auto']
    });

    groupDropdown.panelPosition = locale.uiLanguageDirection === 'rtl' ? 'se' : 'sw';

    groupDropdown.buttonView.bind('label').to(groupDropdown, 'value');

    groupDropdown.on('execute', (evt) => groupDropdown.value = evt.source.label);

    const headerView = new FormHeaderView(locale);
    headerView.set({
        // use classes from special chars
        class: 'ck-special-characters-navigation',
        label: t('Emoji')
    });

    groupDropdown.delegate('execute').to(headerView);
    headerView.children.add(groupDropdown);

    addListToDropdown(groupDropdown, groups);

    return headerView;
}

function getEmojiGroups(dropdown, locale) {
    const { t } = locale;
    const items = new Collection();

    items.add({
        type: 'button',
        model: new Model()
    });
    items.first.model.set({ label: t('EmojiCategory_All'), withText: true });
    items.first.model.set('emojiCategory', 'All');

    // extract groups from emojibase-data
    const { groups } = emojiBaseDataGroups;
    for (const categoryKey in groups) {
        const name = groups[categoryKey];

        const item = {
            type: 'button',
            model: new Model()
        };
        item.model.set({ label: t(`EmojiCategory_${name}`), withText: true });
        item.model.set('emojiCategory', categoryKey);

        item.model.bind('isOn').to(dropdown, 'value', (value) => value === item.model.label);

        items.add(item);
    }

    return items;
}

export { createHeaderView };